import { Try } from "@mui/icons-material";
import axios from "axios";

var apiUrl = process.env.REACT_APP_API_URL;
//var apiUrl = "http://172.27.184.102:8100/api/v2/";
const Forecast = async (latlng, days) => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.get(apiUrl + "weather/forecast", {
      params: {
        latlon: latlng,
        days: days,
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log(response)
    return response;
  } catch (err) {
    console.log(err);
    throw err;
  }}
};

const ForeCast_service = {
  Forecast,
};

export default ForeCast_service;
